module.exports = __webpack_public_path__ + "img/float_logo.1faae98.png";